@if (recordId && !isLoading) {
    <mat-card appearance="outlined" class="mat-elevation-z4">
        <mat-card-header>
            <mat-card-title>{{ transactionTypeName }}</mat-card-title>
            <sl-dropdown>
                <sl-favorites [id]="recordId" [type]="EntityTypeEnum.Transaction" />
            </sl-dropdown>
        </mat-card-header>
        <mat-card-content>
            <form [formGroup]="formGroup" class="form-horizontal">
                <div class="row">
                    <div class="col-lg-3">
                        <sl-datepicker [control]="formGroup.controls['valueDate']" placeholderKey="Transactions.ValueDate" />
                    </div>
                    <div class="col-lg-3">
                        <mat-form-field>
                            <input
                                matInput
                                type="text"
                                placeholder="{{ 'Transactions.SecurityName' | translate }}"
                                value="{{ securityName }}"
                                disabled />
                        </mat-form-field>
                    </div>
                </div>
                <div class="row">
                    <div class="col-md-6">
                        <h4>{{ 'Transactions.Recipient' | translate }}</h4>
                        <div class="row">
                            <div class="col-md-12">
                                @if (record?.incomingAccountTypeId === 'DB' || record?.incomingAccountTypeId === 'DI') {
                                    <sl-input
                                        type="text"
                                        placeholderKey="Transactions.Bank"
                                        [control]="formGroup.controls['incomingName']" />
                                } @else {
                                    <sl-input
                                        type="text"
                                        placeholderKey="Transactions.Shareholder"
                                        [control]="formGroup.controls['incomingName']" />
                                }
                            </div>
                        </div>
                        <div class="row">
                            <div class="col-md-7">
                                <mat-form-field>
                                    <input
                                        matInput
                                        type="text"
                                        placeholder="{{ 'Transactions.SharesBefore' | translate }}"
                                        value="{{ $safeNavigationMigration(record?.incomingShareBalance) | localizedNumber }}"
                                        disabled />
                                </mat-form-field>
                            </div>
                            <div class="col-md-5">
                                <mat-form-field>
                                    <input
                                        matInput
                                        type="text"
                                        value="{{ ((record?.incomingShareBalance ?? 0) / totalNumberOfShares) * 100 | localizedNumber }}%"
                                        disabled />
                                </mat-form-field>
                            </div>
                        </div>
                        <div class="row">
                            <div class="col-md-7">
                                <mat-form-field>
                                    <input
                                        matInput
                                        type="text"
                                        placeholder="{{ 'Transactions.NumberOfShares' | translate }}"
                                        value="+{{ $safeNavigationMigration(record?.numberOfShares) | localizedNumber }}"
                                        disabled />
                                </mat-form-field>
                            </div>
                            <div class="col-md-5">
                                <mat-form-field>
                                    <input
                                        matInput
                                        type="text"
                                        value="+{{ ((record?.numberOfShares ?? 0) / totalNumberOfShares) * 100 | localizedNumber }}%"
                                        disabled />
                                </mat-form-field>
                            </div>
                        </div>
                        <div class="row">
                            <div class="col-md-7">
                                <mat-form-field>
                                    <input
                                        matInput
                                        type="text"
                                        placeholder="{{ 'Transactions.SharesAfter' | translate }}"
                                        value="{{ (record?.incomingShareBalance ?? 0) + (record?.numberOfShares ?? 0) | localizedNumber }}"
                                        disabled />
                                </mat-form-field>
                            </div>
                            <div class="col-md-5">
                                <mat-form-field>
                                    <input
                                        matInput
                                        type="text"
                                        value="{{
                                            ((!record ? 0 : record.incomingShareBalance + record.numberOfShares) / totalNumberOfShares)
                                                * 100 | localizedNumber
                                        }}%"
                                        disabled />
                                </mat-form-field>
                            </div>
                        </div>
                        <div class="row">
                            <div class="col-md-12">
                                <sl-input type="text" placeholderKey="General.Remarks" [control]="formGroup.controls['remarks']" />
                            </div>
                        </div>
                    </div>
                    <div class="col-md-6">
                        <h4>{{ 'Transactions.Sender' | translate }}</h4>
                        <div class="row">
                            <div class="col-md-12">
                                <sl-input type="text" placeholderKey="Transactions.Bank" [control]="formGroup.controls['outgoingName']" />
                            </div>
                        </div>
                    </div>
                </div>
            </form>
        </mat-card-content>
    </mat-card>
}
